import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

interface LanguageFlagProps {
  src: any
  href: string
  label: string
  onClick?: () => void
  className?: string // Add optional className for flexibility
}

const LanguageFlag: React.FC<LanguageFlagProps> = ({
  src,
  href,
  label,
  onClick,
  className = 'w-12 h-12 sm:w-16 sm:h-16', // Default responsive sizes
}) => (
  <Link href={href} passHref legacyBehavior>
    <div
      className="flex flex-col items-center gap-1 cursor-pointer"
      title={label}
      onClick={onClick}
    >
      <Image
        src={src}
        alt={`${label} flag`}
        width={64}
        height={64}
        className={`object-contain ${className}`}
      />
      <span className="text-xs sm:text-sm">{label}</span>
    </div>
  </Link>
)

export default LanguageFlag
